import React from 'react'

export default function AsignacionAnalistas() {
  return (
    <div>
      AsignacionAnalistas
    </div>
  )
}
